"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** TODO */
var Severity;
(function (Severity) {
    /** TODO */
    Severity["Fatal"] = "fatal";
    /** TODO */
    Severity["Error"] = "error";
    /** TODO */
    Severity["Warning"] = "warning";
    /** TODO */
    Severity["Info"] = "info";
    /** TODO */
    Severity["Debug"] = "debug";
    /** TODO */
    Severity["Critical"] = "critical";
})(Severity = exports.Severity || (exports.Severity = {}));
//# sourceMappingURL=models.js.map


//////////////////
// WEBPACK FOOTER
// ../.semaphore-cache/solaris-frontend/node_modules/@sentry/shim/dist/models.js
// module id = 930
// module chunks = 19